import React from 'react';

export const IconFeedback = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 100 100"
		fill="currentColor"
		stroke="currentColor"
		{...props}
	>
		<path
			id="Feedback-Original"
			d="M89.1 9.3H10.9c-4.6 0-8.4 3.8-8.4 8.4v45.5c0 4.6 3.8 8.4 8.4 8.4h6.3v11.3c0 3.2 1.9 6 4.8 7.3 1 .4 2 .6 3 .6 2 0 4-.8 5.5-2.3l16.8-16.8h41.6c4.6 0 8.4-3.8 8.4-8.4V17.7c.2-4.7-3.6-8.4-8.2-8.4zm2.4 53.9c0 1.3-1.1 2.4-2.4 2.4H46.2c-.8 0-1.6.3-2.1.9L26.4 84.2c-.8.8-1.6.5-2 .4-.3-.1-1.1-.6-1.1-1.7V68.6c0-1.7-1.4-3-3-3h-9.4c-1.3 0-2.4-1.1-2.4-2.4V17.7c0-1.3 1.1-2.4 2.4-2.4h78.2c1.3 0 2.4 1.1 2.4 2.4v45.5z"
		></path>
		<path
			id="Feedback-Original"
			d="M80.9 36.4l-4.5-.7-2.1-4.2c-.2-.4-.6-.6-1-.6s-.8.2-1 .6l-2 4.1-4.6.7c-.4.1-.8.4-.9.8-.1.4 0 .8.3 1.1l3.3 3.2-.9 4.6c-.1.4.1.8.4 1.1.3.2.8.3 1.2.1l4.1-2.1 4.1 2.2c.2.1.3.1.5.1s.5-.1.7-.2c.3-.3.5-.7.4-1.1l-.8-4.5 3.3-3.3c.3-.3.4-.7.3-1.1-.1-.4-.4-.7-.8-.8zM57.6 36.4l-4.5-.7-2.1-4.1c-.2-.4-.6-.6-1-.6s-.8.2-1 .6l-2 4.1-4.6.7c-.4.1-.8.4-.9.8-.1.4 0 .8.3 1.1l3.3 3.2-.8 4.5c-.1.4.1.8.4 1.1.3.2.8.3 1.2.1l4.1-2.1 4.1 2.2c.2.1.3.1.5.1s.5-.1.7-.2c.3-.3.5-.7.4-1.1l-.8-4.5 3.3-3.3c.3-.3.4-.7.3-1.1-.1-.4-.5-.7-.9-.8zM34.4 36.4l-4.5-.7-2.1-4.2c-.2-.4-.6-.6-1-.6s-.8.2-1 .6l-2 4.1-4.6.7c-.4.1-.8.4-.9.8-.1.4 0 .8.3 1.1l3.3 3.2L21 46c-.1.4.1.8.4 1.1.3.2.8.3 1.2.1l4.1-2.1 4.1 2.2c.2.1.3.1.5.1s.5-.1.7-.2c.3-.3.5-.7.4-1.1l-.8-4.5 3.3-3.3c.3-.3.4-.7.3-1.1-.1-.4-.4-.7-.8-.8z"
		></path>
	</svg>
);
